import { render, staticRenderFns } from "./documents-table.vue?vue&type=template&id=9fa10ba8&scoped=true"
import script from "./documents-table.vue?vue&type=script&lang=js"
export * from "./documents-table.vue?vue&type=script&lang=js"
import style0 from "./documents-table.vue?vue&type=style&index=0&id=9fa10ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa10ba8",
  null
  
)

export default component.exports